<ion-row class="ion-no-margin allergen-info-box">

  <ion-col no-padding>
    <p class="title-text">{{ titleCopy }}</p>
    <p class="body-text">{{ bodyCopy }}</p>
  </ion-col>

</ion-row>